// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetDynamicFormPayloadRequestModel from '../../model/get-dynamic-form-payload-request-model';
import GetDynamicFormPayloadRequestDTO from '../dto/get-dynamic-form-payload-request-dto';
import dtoSchema from '../schemas/get-dynamic-form-payload-request-schema';

export default abstract class GetDynamicFormPayloadRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetDynamicFormPayloadRequestDTO>) {
    super();
    if (data) {
      this.appSystemKey = data.appSystemKey;
      this.formDefinitionId = data.formDefinitionId;
      this.contactId = data.contactId;
    }
  }
  /**
  */
  appSystemKey?: string;
  /**
  */
  formDefinitionId?: string;
  /**
  */
  contactId?: string;

  static toModel(dto: DeepPartial<GetDynamicFormPayloadRequestDTO>): GetDynamicFormPayloadRequestModel;
  static toModel(dto: DeepPartial<GetDynamicFormPayloadRequestDTO> | undefined | null): GetDynamicFormPayloadRequestModel | undefined;
  static toModel(dto: DeepPartial<GetDynamicFormPayloadRequestDTO> | undefined | null): GetDynamicFormPayloadRequestModel | undefined {
    return dto ? new GetDynamicFormPayloadRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetDynamicFormPayloadRequestModel> | GetDynamicFormPayloadRequestModel): GetDynamicFormPayloadRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      appSystemKey: unwrapped.appSystemKey,
      formDefinitionId: unwrapped.formDefinitionId,
      contactId: unwrapped.contactId,
    } as GetDynamicFormPayloadRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetDynamicFormPayloadRequestModel, can not map to GetDynamicFormPayloadRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
